import './EventsGrid.scss';
import template from './EventsGrid.vhtml';

export default {
	name: 'EventsGrid',
	template: template,
	props: {
		includes: {
			type: [Number, String],
			default: '',
		},
		type: {
			type: String,
			default: 'ALL',
			validator: value => ['ALL', 'BUSINESS', 'STUDENT'].indexOf(value) !== -1,
		},
		getMoreResults: {
			type: Boolean,
			default: true,
		}
	},
	computed: {
		amount: vm => vm.getMoreResults ? 6 : 4,
		wrapperClasses: vm => {
			const dynamicClasses = {
				'events__results-wrapper--min-height events__results-wrapper--fixed-top-pad': vm.getMoreResults,
				'events__results-wrapper--fixed-top-pad': !vm.getMoreResults,
			};

			return ['events__results-wrapper', dynamicClasses];
		},
		resultClasses: vm => {
			const dynamicClasses = {
				'events__result--width-50perc-from-md': !vm.getMoreResults,
				'events__result--width-33perc-from-lg': vm.getMoreResults,
			};

			return ['events__result', dynamicClasses];
		},
	}
};
